export default "__VITE_ASSET__a60bb329__"